import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Modal from "@ignitesales/react-modal";
import { ConnectedShareViaSms } from "@ignitesales/social-share-sms";
import classnames from "classnames";

const ShareViaSmsModal = ({ active, onClose, className }) => {
  const intl = useIntl();
  const classes = classnames(className, "shareViaSms");

  const [messageSent, setMessageSent] = useState(false);

  const onMessageSent = () => {
    setMessageSent(true);
  };

  const onCloseClick = () => {
    onClose();
    setMessageSent(false);
  };

  const renderSentComponent = () => {
    return (
      <div>
        <p>
          <FormattedMessage id="shareViaSms.submitted" />
        </p>
        <button className="btn btn-primary" onClick={onCloseClick}>
          OK
        </button>
      </div>
    );
  };

  return (
    <Modal
      show={active}
      className={classes}
      title={intl.formatMessage({ id: "shareViaSms.title" })}
      onClose={onCloseClick}
      nodeId="root"
      closeBtn={
        <i className="fa fa-times-circle" role="img" aria-label="Close" />
      }
    >
      {messageSent ? (
        renderSentComponent()
      ) : (
        <ConnectedShareViaSms
          onSubmit={onMessageSent}
          hasBeenClicked={active}
        />
      )}
    </Modal>
  );
};

export default ShareViaSmsModal;
